"use strict";

var Aging = function () {
  
  var set_ledger_account_codes = function(dc) {
    if ($('option:selected',dc).attr('value') == "debit"){
        $("#aging_ledger_account_code1").val("120");
        $("#aging_ledger_account_code2").val("120999999");
      } else {
        $("#aging_ledger_account_code1").val("320");
        $("#aging_ledger_account_code2").val("320999999");
      }
  };
  
  $(document).on('change', '#aging_debit_credit', function(event) {
    set_ledger_account_codes(this);
  });
  
  var set_partner_inputs = function(dc) {
    if ($('option:selected',dc).attr('value') == "consolide") {
      $('#company_single_div').hide();
     } else {
      $('#company_single_div').show();
     }
  };
  
  $(document).on('change', '#partner_input', function(event) {
    set_partner_inputs(this);
  });
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Aging;
}
